angular.module('core').service('translationService', ['$q', '$injector', '$rootScope', function($q, $injector, $rootScope) {
    var translations = {}; // Cache for translations
    var loadingPromises = {}; // Cache for loading promises

    this.loadTranslations = function(locale) {
        if (!loadingPromises[locale]) {
            loadingPromises[locale] = $injector.get('$http')
                .get('resources/i18n/angularJS/' + locale + '.json')
                .then(function(response) {
                    if (response.status === 200) {
                        translations[locale] = response.data;
                        return response.data;
                    } else {
                        console.error('Failed to load translations for locale:', locale);
                        translations[locale] = {};
                        return {};
                    }
                });
        }
        return loadingPromises[locale];
    };

    this.getTranslations = function(locale) {
        // Always return an object synchronously
        // If translations aren't loaded yet, trigger loading but return empty object immediately
        if (!translations[locale]) {
            // Trigger loading asynchronously if not already started
            if (!loadingPromises[locale]) {
                this.loadTranslations(locale);
            }
            return {}; // Return empty object immediately
        }
        return translations[locale] || {};
    };

    this.isTranslationsLoaded = function(locale) {
        return !!translations[locale];
    };

    this.preloadDefaultTranslations = function() {
        var locale = $injector.get('localeService').getLocale();
        return this.loadTranslations(locale);
    };
}]);
